/*
  Corsa cart extras: places the banner, free shipping progress bar and
  recommended products from sections/corsa-cart-drawer-content.liquid into
  Dawn's cart drawer and cart page, and refreshes them on every cart change.
*/
(function () {
  var root = document.getElementById('CorsaCartExtras');
  if (!root) return;
  var cfg = root.dataset;
  var cart = null;
  var timer = null;
  var fetching = false;

  function cartUrl() { return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart'; }
  function fromTpl(id) {
    var t = document.getElementById(id);
    return t && t.content && t.content.firstElementChild ? t.content.firstElementChild.cloneNode(true) : null;
  }
  function rate() {
    var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  }
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function isCartPage() { return !!document.getElementById('main-cart-items'); }

  function fillBar(bar) {
    var threshold = Math.round(parseInt(cfg.threshold || '0', 10) * rate());
    if (!threshold || !cart) return;
    var total = cart.total_price;
    var msg = bar.querySelector('[data-corsa-bar-msg]');
    var fill = bar.querySelector('[data-corsa-bar-fill]');
    var track = bar.querySelector('.corsa-cart-bar__track');
    var pct = Math.min(100, Math.floor((total / threshold) * 100));
    if (total >= threshold) {
      msg.textContent = cfg.unlockedLabel;
      msg.classList.add('corsa-cart-bar__msg--reached');
      pct = 100;
    } else {
      msg.textContent = (cfg.progressLabel || '').replace('{amount}', money(threshold - total, cart.currency));
      msg.classList.remove('corsa-cart-bar__msg--reached');
    }
    fill.style.width = pct + '%';
    track.setAttribute('aria-valuenow', pct);
  }

  function filterRecs(recs) {
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });
    var max = parseInt(cfg.recCount || '3', 10);
    var shown = 0;
    recs.querySelectorAll('.corsa-cart-rec__item').forEach(function (item) {
      var show = !inCart[item.dataset.productId] && shown < max;
      item.hidden = !show;
      if (show) shown++;
    });
    recs.hidden = shown === 0;
  }

  function ensure(parent, key, tplId, place) {
    if (!parent) return null;
    var el = parent.querySelector('[data-corsa-cart-el="' + key + '"]');
    if (!el) {
      el = fromTpl(tplId);
      if (!el) return null;
      place(el);
    }
    return el;
  }

  function render() {
    if (!cart) return;
    var hasItems = cart.item_count > 0;

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var header = drawer.querySelector('.drawer__header');
      var items = drawer.querySelector('cart-drawer-items');
      var ann = null;
      if (header && cfg.showAnnouncement === 'true') {
        ann = ensure(drawer, 'announcement', 'CorsaCartAnnouncementTpl', function (el) { header.insertAdjacentElement('afterend', el); });
        if (ann) ann.hidden = !hasItems;
      }
      if (header && cfg.showBar === 'true') {
        var bar = ensure(drawer, 'bar', 'CorsaCartBarTpl', function (el) { (ann || header).insertAdjacentElement('afterend', el); });
        if (bar) { bar.hidden = !hasItems; if (hasItems) fillBar(bar); }
      }
      if (items && cfg.recDrawer === 'true') {
        var recs = ensure(items, 'recs', 'CorsaCartRecsTpl', function (el) { items.appendChild(el); });
        if (recs) { if (hasItems) filterRecs(recs); else recs.hidden = true; }
      }
    }

    var mainItems = document.getElementById('main-cart-items');
    if (mainItems) {
      if (cfg.barPage === 'true') {
        var titleWrap = mainItems.querySelector('.title-wrapper-with-link');
        var pageBar = ensure(mainItems, 'bar', 'CorsaCartBarTpl', function (el) {
          if (titleWrap) titleWrap.insertAdjacentElement('afterend', el);
          else (mainItems.querySelector('.page-width') || mainItems).prepend(el);
        });
        if (pageBar) { pageBar.hidden = !hasItems; if (hasItems) fillBar(pageBar); }
      }
      var footer = document.getElementById('main-cart-footer');
      if (footer && cfg.recPage === 'true') {
        var host = footer.parentElement;
        var pageRecs = host.querySelector('[data-corsa-cart-el="recs"]');
        if (!pageRecs) {
          var r = fromTpl('CorsaCartRecsTpl');
          if (r) {
            r.classList.add('corsa-cart-rec--page');
            var wrap = document.createElement('div');
            wrap.className = 'page-width';
            wrap.appendChild(r);
            footer.insertAdjacentElement('afterend', wrap);
            pageRecs = r;
          }
        }
        if (pageRecs) { if (hasItems) filterRecs(pageRecs); else pageRecs.hidden = true; }
      }
    }
  }

  function refresh() {
    if (fetching) return;
    fetching = true;
    fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { cart = data; render(); })
      .catch(function () {})
      .finally(function () { fetching = false; });
  }
  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-corsa-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: parseInt(btn.dataset.corsaAdd, 10),
        quantity: 1,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'Add to cart failed');
        if (isCartPage()) { window.location.reload(); return; }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);
          scheduleRefresh();
        } else {
          window.location.href = cartUrl();
        }
      })
      .catch(function () { window.location.href = cartUrl(); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  function isOurNode(n) {
    return n.nodeType === 1 && (n.hasAttribute('data-corsa-cart-el') || n.querySelector('[data-corsa-cart-el]'));
  }

  function init() {
    var targets = [document.querySelector('cart-drawer'), document.getElementById('main-cart-items'), document.getElementById('main-cart-footer')];
    var observer = new MutationObserver(function (mutations) {
      var onlyOurs = mutations.every(function (m) {
        return m.removedNodes.length === 0 && Array.prototype.every.call(m.addedNodes, isOurNode);
      });
      if (!onlyOurs) scheduleRefresh();
    });
    targets.forEach(function (t) { if (t) observer.observe(t, { childList: true, subtree: true }); });
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
      }
    } catch (e) {}
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();